<template>
    <v-toolbar class="elevation-1" color="secondary" dark fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer" v-show="!mobileSearch"></v-toolbar-side-icon>
        <v-progress-circular
        indeterminate
        color="white"
        size="24"
        v-show="showProgress"
        ></v-progress-circular>
            <v-toolbar-title style="" class="" v-show="!mobileSearch && !drawer">{{ app.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- mobile search -->
        <!--<v-text-field
            placeholder="Išči..."
            color="white"
            append-icon="close"
            @click:append="hideMobileSearch()"
            prepend-inner-icon="search"
            v-model="search"
            v-show="mobileSearch"
            v-on:keyup.esc="hideMobileSearch()"
            style="width:100%;"
            class="hidden-md-and-up"
            ref="search"
            maxlength="30"
        ></v-text-field>-->
        <v-spacer></v-spacer>
        <!--<v-btn icon class="hidden-md-and-up" @click="btnSearch()" v-show="!mobileSearch">
            <v-icon>search</v-icon>
        </v-btn>-->
        <!--<v-menu offset-y class="hidden-sm-and-down" light>-->
            <v-menu offset-y class="" light v-show="!mobileSearch" bottom left>
            <v-btn slot="activator" color="" icon>
                <v-icon color="white">tune</v-icon>
            </v-btn>
            <!--<v-list class="hidden-sm-and-down" color="grey">-->
                <v-list class="" color="grey" v-show="!mobileSearch">
                <v-list-tile value="true">
                    <v-list-tile-action>
                        <v-icon color="grey darken-3">account_circle</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title><span class="grey--text text--darken-3">{{ user.name }}</span></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <!--<v-list-tile  @click="handleFullScreen()" v-show="!mobile">
                    <v-list-tile-action>
                    <v-icon>fullscreen</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title><span class="grey--text text--darken-3">Fullscreen</span></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>-->
                <v-divider></v-divider>
                <v-list-tile value="true" @click="logout">
                    <v-list-tile-action>
                        <v-icon color="grey darken-3">lock_open</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title><span class="grey--text text--darken-3">Odjava</span></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-toolbar>    
</template>

<script>
import router from '@/router'
import Util from '@/helpers/utilities.js'

export default {
    name: 'app-toolbar',
    components: {

    },
    data: () => ({
        mobileSearch: false
    }),
    
    watch: {

    },

    computed: {
        listMarginLeft() {
            if(this.$vuetify.breakpoint.lgAndUp) {
                return true;
            }

            return false;
        },
        user() {
            return this.$store.getters.user
        }, 

        drawer: {
            get() {
                return this.$store.getters.drawer
            },

            set(newValue) {
                this.$store.commit('SET_DRAWER', newValue)
            }
        },

        toolbarTitle() {
            return this.$store.getters.toolbarTitle
        },

        showProgress() {
            return this.$store.getters.progress
        },

        search: {
            get() {
                return this.$store.getters.search
            },

            set(newSearch) {
                this.$store.commit('SET_SEARCH', newSearch)
            }
        },

        app() {
            return this.$store.getters.app
        },

        mobile() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return true;
            }

            return false;
        }
    },

    methods: {
        logout() {
            this.$store.commit('SET_LOADER_TEXT', 'Odjava uporabnika je v teku...')
            this.$store.commit('SET_LOADER', true)

            this.$store.dispatch('LOGOUT')
            .then(response => {

                setTimeout(() => { 
                    this.$store.commit('SET_LOADER', false) 
                    router.push({
                        name: 'login'
                    })
                }, 800)
            })
            .catch(error =>{
                setTimeout(() => { this.$store.commit('SET_LOADER', false) }, 800),
                window.console.log('Logout error')
                window.console.log(error)

            })
        },

        hideMobileSearch() {
            this.$store.commit('SET_SEARCH', '');
            this.mobileSearch = false;
        },

        btnSearch() {
            this.mobileSearch = !this.mobileSearch
            setTimeout(() =>{
                this.$refs.search.focus();
            }, 500)
        },

        handleFullScreen () {
            Util.toggleFullScreen();
        }
    },

    created() {

    },

    mounted() {

    },

    destroyed() {
        
    }
}
</script>

<style>

</style>




